import API from 'API';

export const findSbs = async (id) => API.find(`sbss/${id}`);

export const findParentSbs = async (sbsId) =>
  API.find(`sbss/${sbsId}/parentSbs`);

export const findSbsByTitleSearch = (title) => API.find('sbss/search', {title});

//query = {title, teamName}
/**
 *
 * @param {Object} query query parameter object passed to the API
 * @param {String} query.title SBS title to search for
 * @param {String} query.teamName SBS team name to search for
 * @returns {Object[]} list of matching SBSs
 */
export const findSbsBySearch = (query) => API.find('sbss/search', query);

export const findTagsBySearch = async (name) => API.find('tags/search', {name});

export const saveTag = async (tag) => API.save(`tags/`, tag);

export const save = async ({id, ...sbs}) =>
  API.save('sbss/', {id: id || '', ...sbs});

export const deleteSbs = async (sbs) => API.delete('sbss/', sbs);

export const findStatuses = async () => API.find('sbsStatuses/');

export const validateUniqueTitle = async (title, id) => {
  if (!title) {
    return 'Title is required';
  } else if (await API.find(`sbss/validateUniqueTitle`, {title, id})) {
    return 'Title already exists';
  } else {
    return '';
  }
};

export const validateUniqueTagName = async (name) => {
  if (!name) {
    return 'Name is required';
  } else if (await API.find(`tags/validateUniqueName`, {name})) {
    return 'Name already exists';
  } else {
    return '';
  }
};

export const canWrite = async (sbsId) => {
  const response = await API.find(`sbss/${sbsId}/canWrite`);

  return response === true;
};

export const canDelete = async (sbsId) => {
  const response = await API.find(`sbss/${sbsId}/canDelete`);

  return response === true;
};

export const calculateTotalSbsTime = (steps) => {
  let ss = 0;
  let mm = 0;
  let hh = 0;

  for (const step of steps) {
    ss += step.ss || 0;
    mm += step.mm || 0;
    hh += step.hh || 0;
  }

  mm += Math.floor((ss - Math.floor(ss / 60)) / 60);
  ss %= 60;
  hh += Math.floor((mm - Math.floor(mm / 60)) / 60);
  mm %= 60;

  return {hh, mm, ss};
};
